export default "__VITE_ASSET__e7e1696c__"